import { eurOr } from "@/lib/wh";

const CARDS = [
  ["items", "Articoli censiti", (v) => v],
  ["available", "Unità disponibili", (v) => v],
  ["sold", "Unità vendute", (v) => v],
  ["removed", "Unità rimosse", (v) => v],
  ["lots", "Lotti attivi", (v) => v],
  ["investment", "Investimento acquisti", eurOr],
  ["potential", "Valore potenziale giacenze", eurOr],
  ["revenue", "Incasso vendite", eurOr],
  ["margin", "Margine realizzato", eurOr],
];

export function StatsGrid({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="wh-stats">
      {CARDS.filter(([k]) => stats[k] !== undefined).map(([k, label, fmt]) => (
        <div key={k} className={`rounded-2xl border p-4 ${k === "margin" ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white border-[var(--border)]"}`} data-testid={`wh-stat-${k}`}>
          <p className={`text-[11px] uppercase tracking-wider ${k === "margin" ? "text-white/60" : "text-[var(--muted)]"}`}>{label}</p>
          <p className="font-heading text-xl sm:text-2xl font-bold mt-1 tabular-nums">{fmt(stats[k])}</p>
        </div>
      ))}
    </div>
  );
}
